/* tslint:disable */
/* eslint-disable */
/**
 * Sds Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DisplayPrice
 */
export interface DisplayPrice {
    /**
     * 
     * @type {boolean}
     * @memberof DisplayPrice
     */
    useText: boolean;
    /**
     * 
     * @type {string}
     * @memberof DisplayPrice
     */
    text?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DisplayPrice
     */
    priceValue: number;
    /**
     * 
     * @type {number}
     * @memberof DisplayPrice
     */
    decimals: number;
    /**
     * 
     * @type {string}
     * @memberof DisplayPrice
     */
    currencySymbol?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DisplayPrice
     */
    currencyIsPrefixed?: boolean;
}

export function DisplayPriceFromJSON(json: any): DisplayPrice {
    return DisplayPriceFromJSONTyped(json, false);
}

export function DisplayPriceFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisplayPrice {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'useText': json['useText'],
        'text': !exists(json, 'text') ? undefined : json['text'],
        'priceValue': json['priceValue'],
        'decimals': json['decimals'],
        'currencySymbol': !exists(json, 'currencySymbol') ? undefined : json['currencySymbol'],
        'currencyIsPrefixed': !exists(json, 'currencyIsPrefixed') ? undefined : json['currencyIsPrefixed'],
    };
}

export function DisplayPriceToJSON(value?: DisplayPrice | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'useText': value.useText,
        'text': value.text,
        'priceValue': value.priceValue,
        'decimals': value.decimals,
        'currencySymbol': value.currencySymbol,
        'currencyIsPrefixed': value.currencyIsPrefixed,
    };
}


